import {APP_NAME} from 'constants/app';
import {imageUtils} from 'utils';

// TODO: move position styles to parent component
export const Logo: React.FC = () => (
    <a href='/'>
        <img src={imageUtils.getLogo()} className='tw-absolute tw-left-6 tw-top-6 tw-w-30' alt={APP_NAME} />
    </a>
);
